import React, { useState } from "react";
import "./SumCourses.css";
import API_CONFIG from "../config/api";

// import s1 from "../assets/menu17.png"
// import s2 from "../assets/menu (18).png"
// import s3 from "../assets/menu (16).png"
// import s4 from "../assets/menu (5).png"
// import s5 from "../assets/menu (3).png"
// import s6 from "../assets/menu (4).png"
// import s7 from "../assets/menu (8).png"
// import s8 from "../assets/menu (6).png"
// import s9 from "../assets/menu (7).png"
// import s10 from "../assets/menu (14).png"
// import s11 from "../assets/menu (12).png"
// import s12 from "../assets/menu (13).png"
// import s13 from "../assets/menu (11).png"
// import s15 from "../assets/menu (10).png"
// import s16 from "../assets/menu (15).png"



const SumCourses = ({ heading }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const courses = [
    {
      title: "Mental Math Abacus",
      age: "Age: 5-12",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-14.png",
      link: "/abacus_home",
    },
    // {
    //   title: "Civil Engineering",
    //   age: "Age: 5-7",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 13.png",
    //   link: "/engineering_civil",
    // },
    // {
    //   title: "Architecture & Interior Design",
    //   age: "Age: 5-7",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-13.png",
    //   link: "/architectureInteriorDesign",
    // },
    {
      title: "AI Prompt Engineering",
      age: "Age: 8-12",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Coding/Group 22-4.png",
      link: "/oding_ai_promptengineer",
    },
    {
      title: "Graphic Designing",
      age: "Age: 6-12",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12.png",
      link: "/graphic_designing_portal",
    },
    {
      title: "Scratch Programming",
      age: "Age: 6-12",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-1.png",
      link: "/coding_scratch",
    },
    // ✅ Newly added courses
    {
      title: "App Development",
      age: "Age: 8-12",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-5.png",
      link: "/coding_app_development",
    },
    // {
    //   title: "Game Development",
    //   age: "Age: 12-18",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-3.png",
    //   link: "/coding_game_development",
    // },
    {
      title: "Unity Game Development",
      age: "Age: 12-18",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-3.png",
      link: "/coding_game_dev_unity",
    },
    // {
    //   title: "Web Development",
    //   age: "Age: 10+",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-4.png",
    //   link: "/coding_web_development",
    // },
    {
      title: "AI & Data Science",
      age: "Age: 12-18",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-11.png",
      link: "/coding_ai_datascience",
    },
    // {
    //   title: "C++",
    //   age: "Age: 12+",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-9.png",
    //   link: "/coding_cplus",
    // },
    {
      title: "Python",
      age: "Age: 12 - 18",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-10.png",
      link: "/coding_python",
    },
    // {
    //   title: "Machine Learning",
    //   age: "Age: 14+",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-8.png",
    //   link: "/coding_machine_learning",
    // },
    // {
    //   title: "PHP",
    //   age: "Age: 12+",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-6.png",
    //   link: "/coding_php",
    // },
    {
      title: "Communication Skills",
      age: "Age: 5-14",
      lessonsPerWeek: 6,
      totalLessons: 12,
      image: "Polymath-images/Menu Pages/Summer/Rectangle 12-7.png",
      link: "/comm_comm_skills",
    },
    // {
    //   title: "Declamation Contest",
    //   age: "Age: 8+",
    //   lessonsPerWeek: 6,
    //   totalLessons: 12,
    //   image: "Polymath-images/Menu Pages/Summer/Rectangle 12-12.png",
    //   link: null, // 🚫 disabled ,
    // },
  ];

  const filteredCourses = courses.filter(course => {
    const searchLower = searchTerm.toLowerCase();
    return (
      course.title.toLowerCase().includes(searchLower) ||
      course.age.toLowerCase().includes(searchLower)
    );
  });

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="summer-courses">
      <h2>{heading}</h2>

      <div className="search-bars">
        <input
          type="text"
          placeholder="Explore Courses by Age or Title"
          value={searchTerm}
          onChange={handleSearch}
        />
        <button onClick={() => setSearchTerm("")}>Clear</button>
      </div>

      <div className="scourses-grid">
        {filteredCourses.length > 0 ? (
          filteredCourses.map((course, index) => (
            <div key={index} className="scourse-card">
              <div className="simage-wrapper">
                <img src={`${API_CONFIG.IMAGES_URL}/${course.image}`} alt={course.title} />
                <span className="ages-badge">{course.age}</span>
              </div>
              <div className="scourse-info">
                <h3>{course.title}</h3>
                <p>Lessons Per Week: {course.lessonsPerWeek}</p>
                <p>Total Lessons: {course.totalLessons}</p>
                <a href={course.link}>
                  <button className="details-btn">Course Detail</button>
                </a>
              </div>
            </div>
          ))
        ) : (
          <div style={{
            gridColumn: '1 / -1',
            textAlign: 'center',
            padding: '40px',
            color: '#666',
            fontSize: '18px'
          }}>
            <p>No courses found matching "{searchTerm}"</p>
            <p style={{ fontSize: '14px', marginTop: '10px' }}>
              Try searching by course title or age (e.g., "5-7", "Python", "Age: 12+")
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SumCourses;
